<template>
  <button
    class="
      btn
      btn-batch
      d-flex
      flex-column
      justify-content-center
      align-items-center
    "
    :class="`btn-${btnClass} text-${textClass} border-${borderClass ? borderClass : btnClass}`"
    v-on="$listeners"
  >
    <i
     :class="`material-icons material-icons-outlined text-${textClass}`"
      v-if="iconName"
    >{{ iconName }}</i>
    <small> <slot /> </small>
  </button>
</template>
<script>
export default {
  props: {
    iconName: '',
    text: '',
    btnClass: '',
    textClass: '',
    borderClass: ''
  }
}
</script>
<style lang="scss" scoped>
.btn-batch {
  height: calc(100% - 12px);
  min-width: 80px;
  min-height: 72px;
  @include media-breakpoint-default() {
    width: 80px;
    height: 72px;
  }
  i {
    @include responsive-fs(24);
    margin-bottom: 5px;
  }
}
@include set-style-on-visible-sw-menu('.btn-batch') {
  width: 80px;
  height: 72px;
};
// TODO change background color of responsive screens
@media (max-width: 1500px) {
  .btn-white:hover {
    background-color: #ffffff;
  }
  .btn-info:hover {
    background-color: #4e66a6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/BatchControlButton.vue